import React from 'react';
import { ScheduleProps } from '../index';

import classnames from 'classnames/bind';
import styles from './schedules.module.scss';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import Icon from '@components/common/assets';
const cx = classnames.bind(styles);

interface SchedulesProps {
  interviewSn: string | null;
  options: ScheduleProps[];
  onClick?: (args: { sn: string; date: string }) => void;
  openModal: (type: string) => void;
}

const Schedules = ({ interviewSn, options, onClick, openModal }: SchedulesProps) => {
  const optionsEl = options.map((option) => {
    const { sn, title, disabled } = option;
    const onChange = () => onClick?.({ sn, date: title });
    const isChecked = interviewSn === option.sn;

    return (
      <div key={sn} className={cx('labelWrap')}>
        <label className={cx('label', { disabled: disabled })}>
          <input
            type="checkbox"
            className={cx('input', 'hidden')}
            checked={isChecked}
            onChange={onChange}
            disabled={disabled}
          />
          <span className={cx('mark', { disabled })} />
          {title}
        </label>
      </div>
    );
  });

  return (
    <div className={cx('scheduleArea')}>
      <div className={cx('title')}>
        <Text fontStyle={FontStyle.B2P_B}>면접 시간</Text>

        {/* 추후에 추가 예정 */}
        {/* <button onClick={() => openModal('COORDINATION')}>
          <Text className={cx('info')} fontStyle={FontStyle.B3_M}>
            일정 조율
            <Icon name="arrowRightLight" width={24} height={24} />
          </Text>
        </button> */}
      </div>
      {optionsEl}
    </div>
  );
};

export default Schedules;
